import { useQuery } from "react-query";
import { getStatusAuthorizedIvideon } from "~/components/Layout/requests/getStatusAuthorizedIvideon";

export default function useGetStatusOwnerIvideon(id: string) {
  return useQuery({
    queryKey: ["statusAuthorizedIvideon", { id }],
    queryFn: () => getStatusAuthorizedIvideon(id),
    refetchOnWindowFocus: false,
    enabled: !!id,
  });
}
